export const Tags = {
    COMMENT: 'COMMENT',
    EVENT: 'EVENT',
    RESPIRATORY: 'RESPIRATORY',
    CENTRAL: 'CENTRAL',
    OBSTRUCTIVE: 'OBSTRUCTIVE',
    APNEA: 'APNEA',
    HYPOPNEA: 'HYPOPNEA',
    DESATURATION: 'DESATURATION',
    POSITION: 'POSITION',
    UPRIGHT: 'UPRIGHT',
    SUPINE: 'SUPINE',
    NONSUPINE: 'NONSUPINE',
    UNKNOWN: 'UNKNOWN',
    SIGNAL: 'SIGNAL',
    DROPOUT: 'DROPOUT',
    ARTIFACT: 'ARTIFACT',
    MOTION: 'MOTION',
    HYPNOGRAM: 'HYPNOGRAM',
    N1: 'N1',
    N2: 'N2',
    N3: 'N3',
    REM: 'REM',
    WAKE: 'WAKE',
};
